import React from "react";
import {
  makeStyles,
  Grid,
  Typography,
  Button,
  Hidden,
  Backdrop,
  CircularProgress,
} from "@material-ui/core";
import ZhLandingPageAppBar from "./ZhLandingPageAppBar";
import { Image } from "semantic-ui-react";
import TextField from "@material-ui/core/TextField";
import image1 from "../assets/images/phone-number-screen.svg";
import { useDispatch } from "react-redux";
import { getOtp } from "../actions/user";
import { useHistory } from "react-router-dom";
import "react-phone-number-input/style.css";
import ReCAPTCHA from "react-google-recaptcha";
import { RECAPTCHA_SITE_KEY } from "../constants/recaptcha";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#ffffff",
  },
  sectionContainer: {
    display: "flex",
    [theme.breakpoints.down("sm")]: {
      minHeight: "80vh",
      alignItems: "center",
      textAlign: "center",
    },
    justifyContent: "center",
    padding: "10%",
    // paddingLeft: '20%'
  },
  FormSection: {
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("sm")]: {
      alignItems: "center",
      textAlign: "center",
      padding: "5%",
      paddingTop: 0,
    },
  },
  ImageSection: {
    display: "flex",
    // alignItems: "flex-start",
    // margin: '5%',
    [theme.breakpoints.down("sm")]: {},
  },
  DashImage: {
    width: "90%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      position: "relative",
    },
  },
  captionText: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 400,
    fontSize: "120%",
    lineHeight: "27px",
    color: theme.palette.primary.main,
    margin: "2% 0",
    [theme.breakpoints.down("sm")]: {},
  },
  button: {
    width: "50%",
    color: theme.palette.defaultWhite.main,
    borderRadius: "20px",
    fontSize: 16,
    fontFamily: theme.typography.fontFamily,
    fontWeight: 600,
    backgroundColor: theme.palette.primary.main,
    "&:hover": {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.primary.main,
    },
    [theme.breakpoints.down("sm")]: {
      width: "auto",
    },
  },
  anchor: {
    textDecoration: "none",
    // order: 3,
  },
  requestDemoMarginBottom: {
    marginBottom: "3em",
    [theme.breakpoints.down("sm")]: {
      marginBottom: "1em",
    },
  },
  mainText: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 700,
    fontSize: "300%",
    color: theme.palette.primary.main,
    lineHeight: "150%",
    [theme.breakpoints.down("sm")]: {
      fontSize: "10vw",
    },
  },
  phoneInputField: {
    marginTop: "5%",
    width: "250px",
    // height: '50px'
  },
  textInput: {
    width: 250,
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  errorText: {
    color: "red",
    fontSize: "0.75rem",
    marginTop: 4,
    marginLeft: 14,
  },
}));

const validationSchema = Yup.object().shape({
  emailId: Yup.string()
    .required("电子邮件是必须的")
    .email("请输入有效的电子邮件地址"),
});

const initialValues = {
  emailId: "",
};

const Main = () => {
  const classes = useStyles();
  const [submitting, setSubmitting] = React.useState(false);
  const [captchaToken, setCaptchaToken] = React.useState(null);
  const recaptchaRef = React.useRef(null);

  const dispatch = useDispatch();
  const history = useHistory();

  const onSubmit = (values) => {
    if (!captchaToken) {
      alert("请完成人机验证");
      return;
    }
    const { emailId } = values;
    var bodyFormData = new FormData();
    bodyFormData.append("mobile_number", "");
    bodyFormData.append("email_id", emailId);
    bodyFormData.append("recaptcha_token", captchaToken);
    dispatch(getOtp(bodyFormData, history, setSubmitting, "zh"));
    localStorage.setItem("phoneNumber", "");
    localStorage.setItem("email", emailId || "");
    localStorage.setItem("countryCode", "");
    sessionStorage.setItem("validSession", true);
    setCaptchaToken(null);
  };

  const handleCaptchaChange = (token) => {
    setCaptchaToken(token);
  };

  const handleCaptchaExpired = () => {
    setCaptchaToken(null);
  };

  return (
    <Grid>
      <ZhLandingPageAppBar registration={true} />
      <Grid className={classes.root}>
        <Grid className={classes.sectionContainer}>
          <Grid item xs={12} md={7} className={classes.FormSection}>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
              validateOnChange
              validateOnBlur
            >
              {({ values, errors, touched }) => (
                <Form>
                  <Grid>
                    <Typography gutterBottom className={classes.mainText}>
                      欢迎来到 <br />
                      TheWatchCloud
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography className={classes.captionText}>
                      想设置您的帐户,
                      只需要输入你的电邮，然后按继续。收到一次性密码和填写基本资料后，便完成注册.
                    </Typography>
                  </Grid>

                  <Grid className={classes.requestDemoMarginBottom}>
                    <Field
                      as={TextField}
                      id="emailId"
                      name="emailId"
                      label="电子邮件"
                      type="email"
                      variant="outlined"
                      margin="normal"
                      size="small"
                      className={classes.textInput}
                      error={(touched.emailId || errors.emailId) && Boolean(errors.emailId)}
                      helperText={((touched.emailId || errors.emailId) && errors.emailId) || ""}
                    />
                  </Grid>
                  <Grid style={{ marginBottom: "1em" }}>
                    <ReCAPTCHA
                      ref={recaptchaRef}
                      sitekey={RECAPTCHA_SITE_KEY}
                      onChange={handleCaptchaChange}
                      onExpired={handleCaptchaExpired}
                    />
                  </Grid>
                  <Grid>
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      className={classes.button}
                      disabled={!values.emailId || !captchaToken}
                    >
                      下一页
                    </Button>
                  </Grid>
                </Form>
              )}
            </Formik>
          </Grid>
          <Hidden smDown>
            <Grid item xs={12} md={6} className={classes.ImageSection}>
              <Image
                src={image1}
                className={classes.DashImage}
              />
            </Grid>
          </Hidden>
          <Backdrop className={classes.backdrop} open={submitting}>
            <CircularProgress color="inherit" />
          </Backdrop>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Main;
